import React from 'react';
import statsData from "./stats.json"
import PieToShow from '../../components/pieToShow'
import { Container, Card, StatsCard, StampCard, Page, Progress} from "tabler-react";

const DashBoard = ({ openMainModal, closeMainModal })=> {
  const { users, revenue, allStats } = statsData;

  return (
    <Container>
      <Page.Header>
        <Page.Title>DashBoard</Page.Title>
      </Page.Header>

      {/* Top Stats */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        columnGap: "16px"
      }}>
        {allStats.map(({text, val}, i) => (
          <div key={i} style={{
            flex: "1  300px",
            minWidth: "300px"
          }}>
            <StatsCard 
              layout={1}
              movement={3}
              total={val}
              label={text}
            />
          </div>
        ))}
      </div>

      {/* Main Section */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        marginTop: "20px",
        gap: "16px"
      }}>

        {/* Left side */}
        <div style={{
          flex: "3 1 600px",
          minWidth: "300px"
        }}>
          
          {/* Revenue cards */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px"
          }}>
            {revenue.map(({text, val, color}, i) => (
              <div key={i} style={{
                flex: "1 1 200px"
              }}>
                <Card className="pb-4 pt-4">
                  <div className="card-body text-center">
                    <div className="h5">{text}</div>
                    <div className="display-4 font-weight-bold mb-4">{val}</div>
                    <Progress size="sm">
                      <Progress.Bar color={color} width={50}/>
                    </Progress>
                  </div>
                </Card>
              </div>
            ))}
          </div>

          {/* Users */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            marginTop: "16px"
          }}>
            {users.map(({text, val, icon, color}, i) => (
              <div key={i} style={{
                flex: "1 1 100px"
              }}>
                <StampCard icon={icon} color={color}>
                  {val}&nbsp;{text}
                </StampCard>
              </div>
            ))}
          </div>

        </div>

        {/* Right charts */}
        <div style={{
          flex: "1 1 250px",
          minWidth: "250px"
        }}>
          <Card>
            <Card.Header>
              <Card.Title>Revenue VS collection</Card.Title>
            </Card.Header>
            <Card.Body className="p-0 text-center">
              <PieToShow type={'donut'} />
            </Card.Body>
          </Card>
        </div>

        <div style={{
          flex: "1 1 250px",
          minWidth: "250px"
        }}>
          <Card>
            <Card.Header>
              <Card.Title>Travelers VS Shippers</Card.Title>
            </Card.Header>
            <Card.Body className="p-0 text-center">
              <PieToShow type={'pie'} />
            </Card.Body>
          </Card>
        </div>

      </div>
    </Container>
  )
}

export default DashBoard;